module.exports = __webpack_public_path__ + "img/needs-clear-coupon.f5da5769.png";